export type Option = {
  label: string;
  value: string;
};

const compareString = (a: string, b: string) => {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};

export const deduplicatedOptionList: (prevList: Option[]) => Option[] = (
  prevList,
) =>
  prevList
    .filter(
      (e, index) => prevList.findIndex((f) => f.value === e.value) === index,
    )
    .sort((a, b) => compareString(a.value, b.value));

export default { Option };
